import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import DropdownSelect from "./components/dropdownSelect";
import { getLeaseTerm, getApeCate } from "../utils";
import LeaseItem from "./components/leaseItem";
import { Toast } from 'antd-mobile';
import ListView from "@/components/AntListView";
import ModalView from "./components/modalView";
import MyModal from "../jewelLand/modal";
import gem from '@/assets/img/landfi/lease-gem.png';
import { hideLoading, showLoading } from "@/components/loading";
import { landApeLeaseList, landApeLease, getGemstoreCount } from "@/api/guland";

const ApeLease = () => {
  const [list, setList] = useState([])
  const [hasMore, setHasMore] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [landLevel, setLandLevel] = useState(0)
  const [leaseTerm, setLeaseTerm] = useState(0)
  const [daysOptions, setDaysOptions] = useState([]);
  const [apeCate, setApeCate] = useState([])
  const currentPage = useRef(1);
  const pageSize = useRef(20);
  const domRef = useRef(null);

  useEffect(() => {
    getDaysOptions()
    getApeCateOptions()
  }, [])

  useEffect(() => {
    getList(true);
  }, [landLevel, leaseTerm])

  const getList = async (isRefresh, loading = true) => {
    try {
      loading && showLoading()
      if(isRefresh) {
        currentPage.current = 1;
        domRef.current?.scroll(0, 0)
      } else {
        currentPage.current = currentPage.current + 1;
      }
      const params = {
        currentPage: currentPage.current,
        pageSize: pageSize.current,
        collectionType: 1,
        rentalPeriod: leaseTerm === 0 ? '': leaseTerm,
        monkeyType: landLevel === 0 ? '': landLevel,
      }
      const res = await landApeLeaseList(params)
      loading && hideLoading()
      if (res.code !== '000000') throw res.msg
      if(currentPage.current === 1) {
        setList(res?.data?.list || [])
      } else {
        setList([...list, ...res?.data?.list]);
      }
      isRefresh && setIsLoad(true);
      setHasMore(res?.data?.list?.length >= pageSize.current)
    } catch (error) {
      hideLoading()
      Toast.show(error)
    }
  }

  const getDaysOptions = async () => {
    try {
      const res = await getLeaseTerm();
      setDaysOptions(res);
    } catch (error) {
      Toast.show(error);
    }
  };

  const getApeCateOptions = async () => {
    try {
      const res = await getApeCate();
      setApeCate(res)
    } catch (error) {
      Toast.show(error);
    }
  };

  const onClickItem = (item) => {
    const ModalInstance = MyModal.show({
      content: <ConfirmLeaseApe onClose={() => ModalInstance?.close()} infoData={item} refresh={getList}/>,
    })
  }

  return <div className={styles.land_lease}>
    <div className={styles.select_box}>
      <DropdownSelect title="等级" options={apeCate} onChange={(item) => setLandLevel(item.value)}/>
      <DropdownSelect title="租期" options={daysOptions} onChange={(item) => setLeaseTerm(item.value)}/>
    </div>
    <div className={styles.land_lease_list} ref={domRef}>
      {
        <ListView
          dataSource={list}
          hasMore={hasMore}
          style={{paddingTop: 5}}
          renderItem={(item) => <LeaseItem item={item} onClick={onClickItem}/>}
          onEndReached={async () => {
            await getList(false, false);
          }}
          isLoad={isLoad}
          customStyle={{imgStyle: {width: 150, height: 150}}}
        />
      }
    </div>
  </div>
}

const ConfirmLeaseApe = ({onClose, infoData, refresh}) => {
  const [gemstoreCounts, setGemstoreCounts] = useState(0)
  const { collectionName, rentalPeriod, nftNo, id, caddress, rentalFee, nftImage, isSelf } = infoData || {}

  useEffect(() => {
    queryGemstoreCounts()
  }, [])

  const confirmLease = async () => {
    if (isSelf === 1) return Toast.show('不能租赁自己的无聊猿');
    if (gemstoreCounts < rentalFee) return Toast.show('宝石不足');
    try {
      showLoading()
      const res = await landApeLease({
        rentalId: id,
        rentalPeriod,
        rentalFee,
      })
      if (res.code !== '000000') throw res.msg
      hideLoading()
      onClose()
      Toast.show('租赁成功')
      refresh && refresh(true, false)
    } catch (error) {
      hideLoading()
      Toast.show(error)
    }
  }

  const queryGemstoreCounts = async () => {
    try {
      const res = await getGemstoreCount()
      if (res?.code !== '000000') throw res?.msg
      setGemstoreCounts(res?.data?.gemstonesCount || 0)
    } catch (error) {
      console.log(error)
    }
  }

  return <ModalView title="确认租赁" onClose={onClose}>
    <div className={styles.confirm_lease_land}>
      <div className={styles.lease_land_top}>
        <div className={styles.land_img}><img src={nftImage} alt="" /></div>
        <div className={styles.land_info}>
          <div className={styles.info_title}>
            <span>{collectionName}</span>
            <span className={styles.common_item}>租期：{rentalPeriod === -1 ? '永久' : rentalPeriod + '天'}</span>
          </div>
          <div className={`${styles.common_item} ${styles.lease_no}`}>编号：{nftNo}</div>
          <div className={`${styles.common_item} ${styles.lease_ape_person}`}>出租人：{caddress}</div>
        </div>
      </div>
      <div className={styles.lease_land_bottom}>
        <div className={styles.gemstore_counts}>当前宝石：{gemstoreCounts}</div>
        <div className={styles.btn_box}>
          <div className={styles.cancel} onClick={onClose}><div className={styles.inner}>取消</div></div>
          <div className={`${styles.confirm} ${(gemstoreCounts >= rentalFee && isSelf === 0) ? '' : styles.disabled}`} onClick={confirmLease}>
            <div className={styles.inner}>
              <img src={gem} alt="" />
              <span>{rentalFee} 租赁</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalView>
}

export default ApeLease;